import React from "react";
import { Progress } from "antd";

import "./styles.css";

export const ProgressCircle = () => {
  const [scrollPercentage, setScrollPercentage] = React.useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    const fullScroll = document.body.scrollHeight - document.body.clientHeight;
    setScrollPercentage(Math.round((position / fullScroll) * 100));
  };

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll, false);
    return () => {
      window.removeEventListener("scroll", handleScroll, false);
    };
  }, []);

  return (
    <div className="progress-circle-container">
      <div className="progress-circle">
        <Progress
          strokeLinecap="square"
          percent={scrollPercentage}
          showInfo={false}
        />
      </div>
    </div>
  );
};

export default ProgressCircle;
